module.exports = __webpack_public_path__ + "img/diagnostic-history-section-ru.4d45e745.jpg";